import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash'
import { useAppDispatch } from "../../hooks/hooks";
import { Swiper, SwiperSlide } from "swiper/react";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { selectEventsCreatedItem, selectEventsListItems } from "../../redux/event/events/selector";
import MembershipCard from "./membership-details-cards.component";
import { selectMembershipsListItems } from "../../redux/memberships/selector";
import { memberships } from "../../redux/memberships/action";
import { YesNoRendererComponent } from "../../common/components/yes-no-renderer.component";
import Popup from "../../common/components/popup";
import AdvisorModal from "./advisor-modal";


export default function Membership() {
    const dispatch = useAppDispatch();
    const Membership = useSelector(selectMembershipsListItems);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectAdvisor, setSelectAdvisor] = useState<any>({});

   const hasFeature = true;
  const noFeature = false;

    const dummyData = [{
        id: 1,
        Name: "Events Name 1"
    },
    {
        id: 2,
        Name: "Events Name 2"
    }, {
        id: 3,
        Name: "Events Name 3"
    }, {
        id: 4,
        Name: "Events Name 4"
    }, {
        id: 5,
        Name: "Events Name 5"
    }]

    const dataToRender = Membership?.result?.items?.length > 0
        ? Membership.result.items
        : dummyData;

    useEffect(() => {
        dispatch(memberships.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/memberships/list`,
            entity: 'memberships',
            jsonData: {}

        }));
    }, []);


     const handleAdvisor = (membership: any) => {
        setSelectAdvisor(membership);
        setShowDetailsModal(true);
    };

    const closeModal = () => {
        setShowDetailsModal(false);
        setSelectAdvisor({});
    };

    const NewItemPopup = () => (
        <Popup onClose={closeModal}>
            <AdvisorModal Close={closeModal}  />
        </Popup>
    );

    return (
        <>
 {showDetailsModal && <NewItemPopup />}
            <div className="font-sans bg-gray-50">

                <div className="relative text-white text-center px-6 py-24 md:py-32 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-700 via-purple-600 to-pink-600 opacity-70"></div>
                    <div className="relative z-10 max-w-4xl mx-auto">
                        <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6 drop-shadow-lg">
                            Empowering Entrepreneurs
                        </h1>
                        <p className="text-xl md:text-2xl font-medium drop-shadow">
                            Learn, Connect & Grow with a powerful tribe of leaders
                        </p>
                    </div>
                </div>

                <div className="text-center mt-16">
                    <h2 className="text-3xl font-semibold">Business Networking Groups in India</h2>
                    <h3 className="text-primary text-2xl font-bold mt-2 underline">ONE Community</h3>
                </div>

                <div className="grid md:grid-cols-3 gap-10 px-6 md:px-20 py-16 text-center">
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Collaboration</h4>
                        <p className="text-gray-600">Join ONE to connect with fellow entrepreneurs and explore collaborations.</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Business Development</h4>
                        <p className="text-gray-600">Weekly sessions to talk about business concerns and growth opportunities.</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Visibility</h4>
                        <p className="text-gray-600">Boost your brand visibility and positioning with powerful networking.</p>
                    </div>
                </div>

                <div className="text-center mt-16">
                    <h2 className="text-3xl font-semibold">Business Networking Groups in India</h2>
                    <h3 className="text-primary text-2xl font-bold mt-2 underline">ONE.Community</h3>
                </div>

                <div className="grid md:grid-cols-3 gap-10 px-6 md:px-20 py-16 text-center">
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Collaboration</h4>
                        <p className="text-gray-600">Join ONE to connect with fellow entrepreneurs and explore collaborations.</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Business Development</h4>
                        <p className="text-gray-600">Weekly sessions to talk about business concerns and growth opportunities.</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
                        <h4 className="text-xl font-bold text-primary mb-3">Visibility</h4>
                        <p className="text-gray-600">Boost your brand visibility and positioning with powerful networking.</p>
                    </div>
                </div>

        
                <div className="bg-white py-16 text-center">
                    <h2 className="text-3xl font-bold text-primary mb-3">Why should you browse further down?</h2>
                    <p className="text-gray-600 text-base mb-10">'Cos this is how our community is growing!</p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-primary text-3xl font-extrabold">
                        <div>
                            <p>80%</p>
                            <p className="text-black font-medium text-sm mt-2">Upskilled through weekly sessions</p>
                        </div>
                        <div>
                            <p>70%</p>
                            <p className="text-black font-medium text-sm mt-2">Tapped into real business opportunities</p>
                        </div>
                        <div>
                            <p>70%</p>
                            <p className="text-black font-medium text-sm mt-2">Collaborated with peers for growth</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex w-full py-10">
                <div className="swiper p-4 w-full" id="slider5">
                    <div className="swiper-wrapper w-full">
                        <Swiper
                            navigation={{
                                nextEl: '.swiper-button-next-ex5',
                                prevEl: '.swiper-button-prev-ex5',
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            breakpoints={{
                                1536: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                                1280: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                320: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {dataToRender.map((item: any, i: any) => {
                                return (
                                    <SwiperSlide key={i}>
                                        <MembershipCard
                                            membership={item} />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>

              <div className="px-6 md:px-10 pb-16">
      <h3 className="text-2xl font-bold mb-6 text-center">📊 Membership Comparison</h3>
      <div className="overflow-auto">
        <table className="min-w-full text-sm border border-gray-200 rounded-lg">
          <thead>
            <tr className=" bg-primary">
              <th className="border px-4 py-2 font-semibold text-left">Features</th>
              <th className="border px-4 py-2 font-semibold text-center">Explorer</th>
              <th className="border px-4 py-2 font-semibold text-center">Builder</th>
              <th className="border px-4 py-2 font-semibold text-center">Pro Operator</th>
              <th className="border px-4 py-2 font-semibold text-center">Enterprise Leader</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">Community Access</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">LMS & Certifications</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Mentorship</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Platform Tools</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">DPI Connectors</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Marketplace Visibility</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Cluster Leadership</td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={noFeature} /></td>
              <td className="border px-4 py-2"><YesNoRendererComponent value={hasFeature} /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

            <div className="bg-[#fff4f0] py-16 px-4 mt-20">
                <h2 className="text-3xl font-bold text-center mb-6 flex justify-center items-center gap-2">
                    <span className="text-yellow-500 text-2xl"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#f5ae3b" fill="none">
                        <path d="M3 12C7.5 12 12 7.5 12 3C12 7.5 16.5 12 21 12C16.5 12 12 16.5 12 21C12 16.5 7.5 12 3 12Z" stroke="#f5ae3b" stroke-width="1.5" stroke-linejoin="round"></path>
                        <path d="M2 19.5C2.83333 19.5 4.5 17.8333 4.5 17C4.5 17.8333 6.16667 19.5 7 19.5C6.16667 19.5 4.5 21.1667 4.5 22C4.5 21.1667 2.83333 19.5 2 19.5Z" stroke="#f5ae3b" stroke-width="1.5" stroke-linejoin="round"></path>
                        <path d="M16 5C17 5 19 3 19 2C19 3 21 5 22 5C21 5 19 7 19 8C19 7 17 5 16 5Z" stroke="#f5ae3b" stroke-width="1.5" stroke-linejoin="round"></path>
                    </svg></span>
                    Ready to Start Your DPI Journey?
                </h2>

                <p className="text-center text-gray-700 max-w-3xl mx-auto mb-10 text-lg">
                    Select a membership that fits your vision and get full support to grow into a DPI-powered Digital Native Enterprise.
                </p>

                <div className="flex justify-center gap-4">
                    <h3 className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800">
                        Get Started
                    </h3>
                    <button
                         onClick={handleAdvisor}
                        className="border border-black text-black px-6 py-2 rounded hover:bg-gray-100"
                    >
                        Talk to an Advisor
                    </button>

                </div>
            </div>

        </>



    );
}


